import { Controller } from "@hotwired/stimulus";

// LRPO-5507 (item 22) — the custom From/To inputs were rendered unconditionally
// ("for v1 always visible with helper text"), so the panel permanently showed a
// date-range control that did nothing unless the "Custom" pill happened to be
// selected. Show them only when Custom is actually chosen.
//
// The date_preset pill group writes its value into a HIDDEN input, and a hidden
// input fires no change event of its own. Two signals are listened for instead:
//   • "change" — filter_pill_group#_syncHidden dispatches a bubbling input+change
//     on every pill toggle, so a click on Custom reaches us.
//   • "filter-diff:values-applied" — dispatched on the drawer root for Reset /
//     preset-load / reloadDraft, where no pill was clicked at all.
// The values-applied handler is deferred a frame: pill_group rebuilds its own hidden
// inputs from the SAME event, and controller invocation order is not guaranteed, so
// reading the hidden input synchronously could read a stale preset.
//
// Inputs are DISABLED as well as hidden. serializeDraft() skips disabled inputs, so
// a from_date the user typed and then switched away from no longer trails along in
// the URL — while the value itself is retained, so toggling Custom back restores it.
export default class extends Controller {
  static targets = ["preset", "range"];

  connect() {
    this._sync = this._sync.bind(this);
    this._syncDeferred = () => requestAnimationFrame(this._sync);

    this.element.addEventListener("change", this._sync);
    document.addEventListener("filter-diff:values-applied", this._syncDeferred);
    this._sync();
  }

  disconnect() {
    this.element.removeEventListener("change", this._sync);
    document.removeEventListener("filter-diff:values-applied", this._syncDeferred);
  }

  _sync() {
    if (!this.hasPresetTarget || !this.hasRangeTarget) return;

    const isCustom = this.presetTarget.value === "custom";
    this.rangeTarget.hidden = !isCustom;
    this.rangeTarget
      .querySelectorAll("input")
      .forEach((input) => { input.disabled = !isCustom; });
  }
}
